import { ActionIcon, Tooltip } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconX } from "@tabler/icons-react";
import { useProfileStore, useSessionStore } from "../../stores/UserStore";
import { useCallback } from "react";
import { useUIStore } from "../../stores/UIStore";
import { updateSelf } from "../../api/UserAPI";
import { switchAuthChannel } from "../../api/axios";
import { getFields } from "../../api/ContactAPI";
import {
  getOtherPrms,
  getStatusCustom,
  getStatusSystem,
} from "../../api/PRMAPI";
import { getGlobalReporting } from "../../api/StatsAPI";
import { getEmails, getLinkedinAccounts } from "../../api/EmailAPI";

const SwitchCancel = ({ navbarClosed }) => {
  const setWindowLoading = useUIStore((s) => s.setWindowLoading);
  const user_switch = useSessionStore((state) => state.user_switch);
  const setSwitch = useSessionStore((state) => state.setUserSwitch);
  const lang = useLanguage((s) => s.language);
  const handleReset = useCallback(() => {
    setSwitch(null);
    useProfileStore.getState().setUnswitchedProfile(null);
    setWindowLoading(true);
    updateSelf()
      .then(() => {
        switchAuthChannel.postMessage({
          type: "SWITCH_STOPPED",
        });
        getFields();
        getOtherPrms();
        getGlobalReporting();
        getStatusSystem();
        getStatusCustom();
        getEmails();
        getLinkedinAccounts();
      })
      .finally(() => setWindowLoading(false));
  }, [setSwitch]);

  if (!user_switch) {
    return null;
  }
  return (
    <Tooltip
      label={lang.footer.return_to_main_account_tooltip}
      position="bottom"
    >
      <ActionIcon
        h={60}
        w={42}
        // variant="light"
        color="red.6"
        px={0}
        onClick={handleReset}
        radius={0}
      >
        <IconX size={19} />
      </ActionIcon>
    </Tooltip>
  );
};

export default SwitchCancel;
